import React from 'react';
import { ArrowRightOutlined, ArrowDownOutlined } from '@ant-design/icons';
import BenchmarkBadge from '../../Marketing/BenchmarkBadge';
import './A2AHero.css';

const A2AHero = ({ ctaLabel, onPrimary, onSeeHow }) => (
  <section className="a2a-hero">
    <div className="a2a-hero__glow" aria-hidden="true" />
    <div className="a2a-hero__inner">
      <BenchmarkBadge page="agent-to-agent" />
      <h1 className="a2a-hero__title aie-display">
        Every CellCog capability,
        <br />
        <span className="a2a-hero__title-accent">available to any agent.</span>
      </h1>
      <p className="a2a-hero__sub">
        Every software will soon have two interfaces: one for people, one for
        agents. CellCog opens everything to OpenClaw, Claude Code, Cursor,
        Hermes, and Linear agents, through one API key or an MCP connection.
      </p>
      <div className="a2a-hero__ctas">
        <button type="button" data-msc-suppress className="aie-btn aie-btn-primary" onClick={() => onPrimary('hero')}>
          {ctaLabel} <ArrowRightOutlined />
        </button>
        <button type="button" className="aie-btn aie-btn-ghost" onClick={onSeeHow}>
          <ArrowDownOutlined /> See how it works
        </button>
      </div>
      <p className="a2a-hero__note">
        Try it free, no credit card needed. Every account starts with 200 credits.
      </p>
    </div>
  </section>
);

export default A2AHero;
